module.exports = __webpack_public_path__ + "img/earth-pos-circle.1fb927fb.png";